import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatNativeDateModule, MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import localeVI from '@angular/common/locales/vi'
import { registerLocaleData } from '@angular/common';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/modules/shared.module';
import { ToastyModule } from 'ng2-toasty';
import { UniqueSelectionDispatcher } from '@angular/cdk/collections';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertComponent } from './_directives';
import { AuthGuard } from './_guards';
import { JwtInterceptor } from './_helpers';
import { AlertService, ApiService } from './_services';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { RegisterComponent } from './register';
import { HttpModule } from '@angular/http';
import { VerifyComponent } from './verify/verify.component';
import { UpdateFirstTimeComponent } from './update-first-time/update-first-time.component';

import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { ResetPasswordConfirmComponent } from './login/reset-password-confirm/reset-password-confirm.component';
import { MatRadioModule, MatStepperModule, MatFormFieldModule, MatInputModule, MatCardModule, MatButtonModule, MatIconModule, MatDatepickerModule, MatProgressSpinnerModule, MatSelectModule, MatGridListModule, MatMenuModule, MatTooltipModule } from '@angular/material';
import { MyAccountComponent } from './my-account/my-account.component';
import  {AlertPopupService}  from './shared/services/alert.service';
import {NgxMaskModule} from 'ngx-mask';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { OauthCallbackComponent } from './oauth-callback/oauth-callback.component';
import { MemberService } from './_services/member.service';
import { WhitelabelService } from './_services/whitelabel.service';
import { ConfigService } from './_services/config.service';
import { SsoComponent } from './sso/sso.component';
import { LoginByTokenComponent } from './login-by-token/login-by-token.component';
import { GenGoldComponent } from './home/benefits/gen-gold/gen-gold.component';
import { TmLifeComponent } from './home/benefits/tm-life/tm-life.component';
import { RfComponent } from './home/benefits/rf/rf.component';
import { SafePipe } from './shared/pipes/safe.pipe';
import { DependentComponent } from './dependent/dependent.component';
import { DependentFormComponent } from './dependent/dependent-form/dependent-form.component';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';
import { DependentService } from './_services/dependent.service';
import { PhonePipe } from './shared/pipes/phone.pipe';
import { RegisterDependentComponent } from './register/register-dependent/register-dependent.component';
import {PopoverModule} from "ngx-smart-popover";
import { SanitizeHtmlPipe } from './shared/pipes/sanitizeHtml.pipe';
registerLocaleData(localeVI);

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    // for development
    // return new TranslateHttpLoader(http, '/start-angular/SB-Admin-BS4-Angular-5/master/dist/assets/i18n/', '.json');
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export function whitelabelProviderFactory(provider: WhitelabelService) {
    return () => provider.load();
  }


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        BrowserAnimationsModule,
        BrowserModule,
        HttpClientModule,
        HttpModule,
        MatStepperModule, MatFormFieldModule, MatInputModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        NgxMaskModule.forRoot(),
        FormsModule,ReactiveFormsModule,
        AppRoutingModule,
       MatCardModule, MatButtonModule, MatIconModule, MatDatepickerModule, MatSelectModule, MatGridListModule,MatMenuModule,MatTooltipModule,
        MatNativeDateModule,CurrencyMaskModule, MatRadioModule, MatProgressSpinnerModule,ToastyModule.forRoot(),

        PopoverModule

    ],
    declarations: [AppComponent, AlertComponent,
        HomeComponent, UpdateFirstTimeComponent,
        LoginComponent, ResetPasswordComponent, ResetPasswordConfirmComponent,
        RegisterComponent,
        VerifyComponent,
        MyAccountComponent,
        PrivacyPolicyComponent,
        OauthCallbackComponent,
        SsoComponent,
        LoginByTokenComponent,
        GenGoldComponent,
        TmLifeComponent,
        SafePipe, SanitizeHtmlPipe,
        RfComponent,
        DependentComponent,
        DependentFormComponent,
        ConfirmDialogComponent,
        PhonePipe,
        RegisterDependentComponent],
    entryComponents: [
        DependentFormComponent,
        ConfirmDialogComponent
    ],
    providers: [AuthGuard,{
        provide: LOCALE_ID,
        useValue: 'en-US' // 'de-DE' for Germany, 'fr-FR' for France ...
    }, WhitelabelService,
        { provide: APP_INITIALIZER, useFactory: whitelabelProviderFactory, deps: [WhitelabelService], multi: true },
      ApiService, AlertService, UniqueSelectionDispatcher, AlertPopupService, MemberService, ConfigService, DependentService,
      {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts